if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        if (!this.submitButton) {
          this.hideErrors = this.dataset.hideErrors === 'true';
          this.nativeState = window.GJNative?.initialise(this);
          return;
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.nativeState = window.GJNative?.initialise(this);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.dataset.nativeBlocked === 'true') return;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.handleErrorMessage();
        let added = false;
        try {
          if (this.dataset.productId && !window.GJNative) throw new Error(window.cartStrings.error);
          await this.nativeState?.ready;
          if (this.nativeState?.failure) throw this.nativeState.failure;
          const invalid = [...this.form.elements].find((field) => field.willValidate && !field.validity.valid);
          if (invalid) {
            const details = invalid.closest('details');
            if (details) details.open = true;
            invalid.reportValidity();
            return;
          }
          if (!this.variantIdInput.value || this.variantIdInput.disabled) throw new Error(window.GJNative?.messages.variantError || window.cartStrings.error);
          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const context = await window.GJNative?.prepare(this, formData);
          if (variantId !== this.variantIdInput.value || this.submitButton.disabled) throw new Error(window.GJNative?.messages.variantError || window.cartStrings.error);
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          const result = await fetch(routes.cart_add_url, config);
          let response = await result.json();
          if (!result.ok || response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source:'product-form', productVariantId:variantId, errors:response.errors || response.description, message:response.message });
            throw new Error(response.description || response.message || window.cartStrings.error);
          }
          added = true;
          if (response.items?.length) {
            const primary = response.items.find((item) => String(item.id) === String(variantId)) || response.items[0];
            response = { ...primary, ...response };
          }
          if (context) response = await window.GJNative.finishEdit(this, response, context);
          if (!this.cart || (this.closest('.gj-pdp-v2') && this.cart.localName !== 'cart-drawer')) {
            window.location = window.routes.cart_url;
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source:'product-form', productVariantId:variantId, cartData:response });
          this.cart.classList.remove('is-empty');
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => this.cart.renderContents(response), { once:true });
            quickAddModal.hide(true);
          } else this.cart.renderContents(response);
        } catch (error) {
          this.handleErrorMessage(error.message || window.GJNative?.messages.cartError || window.cartStrings.error);
          if (added) {
            // Cart add succeeded, so never offer a silent duplicate retry after a rendering/edit failure.
            this.submitButton.disabled = true;
            const link = document.createElement('a');
            link.href = window.routes.cart_url; link.textContent = window.cartStrings.viewCart || 'View cart';
            this.errorMessage?.append(document.createTextNode(' '), link);
          }
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (this.dataset.nativeBlocked === 'true') { this.submitButton.disabled = true; return; }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
